import { render, staticRenderFns } from "./LoadingApp.vue?vue&type=template&id=34abe2b6&"
import script from "./LoadingApp.vue?vue&type=script&lang=js&"
export * from "./LoadingApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports